import {
    onCreateStaffByGroup,
    onUpdateStaffByGroup,
    onDeleteStaffByGroup
} from '../../subscriptions';
import store from '@/store'
import { initializeSubscription, disconnectSubscription } from '../helper'
import { recalculateDaPerformanceData } from '@/views/DaPerformanceReport/calculateDaPerformanceReport'
import { messengerLoadNotifications } from '../nested/messengerSubscriptions'
import { updateAssociateMessengerPhotoUrl } from '@/views/Messenger/countUnreadMessages'
import { apiPostCompressed } from '@/utilities/apiCallCompressed'

"use strict";
let subscriptionAssociates = null
let associatesRDS = [];

export const loadAssociates = async function() {
    if(!store.state.userInfo?.tenant?.group) return
    await loadAssociatesFromRDS(store.state.userInfo.tenant.group)
    store.dispatch("subscriptionStore/setAssociateList", associatesRDS)
    messengerLoadNotifications()
}

async function loadAssociatesFromRDS(group) {
    let body = {
        filters: { group },
        queryName: "staffByGroupWithConnections",
        includeConnections: true,
        isMapped: true,
        sort: { direction: "ASC", field: "firstName" }
    }

    try {
        const results = await apiPostCompressed('rds', '/query/Staff', { body })
        if (results?.data?.length) {
            associatesRDS = results.data
        } else {
            associatesRDS = []
        }
    } catch (error) {
        console.log("Error in loadAssociates", error)
        associatesRDS = []
    }
}

export const associateSubscribe = function(instance) {
    const queries = {
        onCreateStaffByGroup,
        onUpdateStaffByGroup,
        onDeleteStaffByGroup
    }
    if(!store.state.userInfo?.tenant?.group) return
    const input = {
        group: store.state.userInfo.tenant.group
    }
    initializeSubscription(subscriptionAssociates, queries, input, "subscriptionStore/mutateAssociate", instance)
}

export const config = function(subscriptions) {
    const subscription = {}
    subscriptionAssociates = subscriptions['associate'] = {
        loadList: loadAssociates,
        subscribe: associateSubscribe,
        unsubscribe: (instance) => disconnectSubscription(subscription, instance),
        callback: associateEventCallback,
        subscription
    }
}

export const associateEventCallback = async function(subscriptionState, {data: associate, eventName}) {
    switch(eventName) {
        case 'onUpdate': {
            updateAssociateMessengerPhotoUrl(associate)
            break
        }
        case 'onCreate':
        case 'onDelete': {
            break
        }
    }
    await recalculateDaPerformanceData(false)
}
